import { createComponent } from '@ycos/fela'
import { bool, string } from 'prop-types'
import { getFontStyles } from '../'

const CTA_MAX_WIDTH = '326px'

const buttonBaseStyles = ({ display, theme }) => ({
  ...theme.custom.button.default,
  ...getFontStyles(theme.typography, { type: 'Label', name: '1' }),
  ...displayType(display),

  width: '100%',
  height: '40px',
  borderRadius: '2px',
  textAlign: 'center',
  cursor: 'pointer',
  direction: 'ltr',

  ':focus': {
    outline: 0
  }
})

const displayType = (display) => (display === 'block' ? {} : { maxWidth: CTA_MAX_WIDTH })

const Button = createComponent(
  'Button',
  ({ disabled, display, theme, inverted }) => ({
    ...buttonBaseStyles({ display, theme }),
    ...(disabled ? theme.custom.button.disabled : { ':hover': theme.custom.button.hover }),
    ...(inverted ? theme.custom.button.inverse : {}),
    ...(inverted ? { ':hover': theme.custom.button.hoverInverse } : {})
  }),
  'button',
  ['onClick']
)

Button.propTypes = {
  disabled: bool,
  display: string
}

Button.defaultProps = {
  disabled: false,
  display: 'inline-block'
}

export const ButtonOutline = createComponent(
  'ButtonOutline',
  ({ disabled, display, theme }) => ({
    ...buttonBaseStyles({ display, theme }),
    ...theme.custom.button.inverse,
    ...(disabled ? theme.custom.button.disabled : { ':hover': theme.custom.button.hoverInverse })
  }),
  'button',
  ['onClick']
)

export default Button
